module.exports = __webpack_public_path__ + "media/logos/techcrunch-logo-white-7ccc3154.png";